import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function UniqueMechanism() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-20 px-6 md:px-12" data-id="element-120">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto space-y-8 text-center" data-id="element-121">
        <div className="inline-flex items-center gap-3 bg-teal-accent/10 border border-teal-accent/30 px-6 py-3 rounded-full cyan-glow" data-id="element-122">
          <SparklesIcon className="w-5 h-5 text-teal-accent" data-id="element-123" />
          <span className="text-teal-accent font-semibold uppercase tracking-wide text-sm" data-id="element-124">
            The Solution
          </span>
        </div>

        <h2 className="text-4xl md:text-6xl font-bold text-white" data-id="element-125">
          Introducing The Symptom-Link™ Protocol
        </h2>

        <p className="text-xl text-stone-300 leading-relaxed" data-id="element-126">
          This isn't just a book; it's a translation manual for your biology.
          Through the lens of German New Medicine and Somatic Decoding, this
          system allows you to look up your specific symptom (from A to Z) and
          identify the exact "Bio-Shock" that triggered it.
        </p>

        <p className="text-lg text-stone-400 leading-relaxed" data-id="element-127">
          Once your brain recognizes the truth, the "emergency program" can
          finally stand down, allowing real physical healing to begin.
        </p>
      </motion.div>
    </section>;
}